import { render, staticRenderFns } from "./PurchaseRequest.vue?vue&type=template&id=72806830"
import script from "./PurchaseRequest.vue?vue&type=script&lang=js"
export * from "./PurchaseRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports